/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntAppControllerGetSegmentsFaceRecognitionsByDateQueryResponse, PntAppControllerGetSegmentsFaceRecognitionsByDatePathParams, PntAppControllerGetSegmentsFaceRecognitionsByDateQueryParams } from "../models/PntAppControllerGetSegmentsFaceRecognitionsByDate";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntAppControllerGetSegmentsFaceRecognitionsByDate } from "../axios/pntAppControllerGetSegmentsFaceRecognitionsByDate";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntAppControllerGetSegmentsFaceRecognitionsByDateQueryKey = (slug: PntAppControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"], params: PntAppControllerGetSegmentsFaceRecognitionsByDateQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/facerecognition', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntAppControllerGetSegmentsFaceRecognitionsByDateQueryKey = ReturnType<typeof pntAppControllerGetSegmentsFaceRecognitionsByDateQueryKey>

export function pntAppControllerGetSegmentsFaceRecognitionsByDateQueryOptions(slug: PntAppControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"], params: PntAppControllerGetSegmentsFaceRecognitionsByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntAppControllerGetSegmentsFaceRecognitionsByDateQueryKey(slug, params)
        return queryOptions<PntAppControllerGetSegmentsFaceRecognitionsByDateQueryResponse, ResponseErrorConfig<Error>, PntAppControllerGetSegmentsFaceRecognitionsByDateQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntAppControllerGetSegmentsFaceRecognitionsByDate(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve the face recognitions for a given time range
 * {@link /pnt/v2/segments/:slug/facerecognition}
 */
export function usePntAppControllerGetSegmentsFaceRecognitionsByDate<TData = PntAppControllerGetSegmentsFaceRecognitionsByDateQueryResponse, TQueryData = PntAppControllerGetSegmentsFaceRecognitionsByDateQueryResponse, TQueryKey extends QueryKey = PntAppControllerGetSegmentsFaceRecognitionsByDateQueryKey>(slug: PntAppControllerGetSegmentsFaceRecognitionsByDatePathParams["slug"], params: PntAppControllerGetSegmentsFaceRecognitionsByDateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntAppControllerGetSegmentsFaceRecognitionsByDateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntAppControllerGetSegmentsFaceRecognitionsByDateQueryKey(slug, params)
         

         const query = useQuery({
          ...pntAppControllerGetSegmentsFaceRecognitionsByDateQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}